<template>
  <div class="news-list-item border" @click="toDetails">
    <div class="f-y-center f-between m-b-15 w-100b">
      <div class="f-y-center">
        <div class="m-r-15" :class="readed ? 'read': 'un-read'"></div>
        <div class="font gray-font m-r-10">{{time}}</div>
      </div>
      <div class="f-y-center">
        <img v-if="avatar" class="avatarImage m-r-10" :src="avatar" />
        <AvatarImage v-else :avatarUrl="avatar" class="m-r-10" :name="lawyerName" />
        <div class="font m-r-10">{{lawyerName}}</div>
      </div>
    </div>
    <div class="m-l-30 font m-b-20 darkgray-font textarea-content">{{title}}</div>
    <div class="flex w-100b">
      <div class="w-30"></div>
      <div class="content f-1">
        <div class="darkgray-font textarea-content">{{content}}</div>
        <img
          v-for="(item, index) in fileList"
          :key="index"
          :src="item.validUri"
          class="m-t-20 m-r-30 fileImage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'
// /news/details/:id
export default {
  props: {
    readed: Boolean,
    title: String,
    lawyerName: String,
    time: String,
    content: String,
    avatar: String,
    fileList: Array,
    tblId: Number,
    processNodeTblId: Number,
  },
  setup(props, { emit }) {
    const toDetails = () => {
      router.push({
        path: '/news/details',
        query: {
          tblId: props.tblId,
          processNodeTblId: props.processNodeTblId,
        },
      })
    }
    return { toDetails }
  },
}
</script>

<style lang="scss">
.news-list-item {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  padding: 20px 20px 30px 20px;
  background-color: #fff;

  .avatarImage {
    width: 54px;
    height: 54px;
    border-radius: 50%;
  }
  .content {
    background-color: #f4f6f9;
    border-radius: 14px;
    padding: 25px;
  }
  .fileImage {
    width: 82px;
    height: 82px;
    border-radius: 4px;
  }
}
</style>